import { render } from "./HelloWorld.vue?vue&type=template&id=7d381216&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=7d381216&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d381216"]])

export default __exports__